import * as T from './types';
import CampaignAPI from '../../../api/electoralCampaign/campaign';
import TasksAPI from '../../../api/electoralCampaign/tasks';
import EventsAPI from '../../../api/electoralCampaign/events';
import ScriptsAPI from '../../../api/electoralCampaign/scripts';
import WorkersAPI from '../../../api/electoralCampaign/workers';
import FieldAPI from '../../../api/electoralCampaign/field';
import MediaAPI from '../../../api/electoralCampaign/mediaAssets';
import MapAPI from '../../../api/electoralCampaign/map';
import PinsAPI from '../../../api/electoralCampaign/pins';

export const actions = {
  async fetchCampaign({ commit }) {
    commit(T.EC_SET_UI_FLAG, { isFetchingCampaign: true });
    try {
      const { data } = await CampaignAPI.get();
      commit(T.EC_SET_CAMPAIGN, data);
    } finally {
      commit(T.EC_SET_UI_FLAG, { isFetchingCampaign: false });
    }
  },
  async updateCampaign({ commit }, payload) {
    const { data } = await CampaignAPI.update(payload);
    commit(T.EC_SET_CAMPAIGN, data);
    return data;
  },
  async fetchTasks({ commit }, opts) {
    commit(T.EC_SET_UI_FLAG, { isFetchingTasks: true });
    try {
      const { data } = await TasksAPI.list(opts);
      commit(T.EC_SET_TASKS, data);
    } finally {
      commit(T.EC_SET_UI_FLAG, { isFetchingTasks: false });
    }
  },
  async createTask({ commit }, payload) {
    const { data } = await TasksAPI.create(payload);
    commit(T.EC_UPSERT_TASK, data);
    return data;
  },
  async updateTask({ commit }, { id, ...payload }) {
    const { data } = await TasksAPI.update(id, payload);
    commit(T.EC_UPSERT_TASK, data);
    return data;
  },
  async deleteTask({ commit }, id) {
    await TasksAPI.delete(id);
    commit(T.EC_REMOVE_TASK, id);
  },
  async fetchEvents({ commit }, opts) {
    const { data } = await EventsAPI.list(opts);
    commit(T.EC_SET_EVENTS, data);
  },
  async createEvent({ commit }, payload) {
    const { data } = await EventsAPI.create(payload);
    commit(T.EC_UPSERT_EVENT, data);
    return data;
  },
  async updateEvent({ commit }, { id, ...payload }) {
    const { data } = await EventsAPI.update(id, payload);
    commit(T.EC_UPSERT_EVENT, data);
    return data;
  },
  async deleteEvent({ commit }, id) {
    await EventsAPI.delete(id);
    commit(T.EC_REMOVE_EVENT, id);
  },
  async fetchScripts({ commit }, opts) {
    const { data } = await ScriptsAPI.list(opts);
    commit(T.EC_SET_SCRIPTS, data);
  },
  async fetchWorkers({ commit }, opts) {
    const { data } = await WorkersAPI.list(opts);
    commit(T.EC_SET_WORKERS, data);
  },
  async createWorker({ commit }, payload) {
    const { data } = await WorkersAPI.create(payload);
    commit(T.EC_UPSERT_WORKER, data);
    return data;
  },
  async updateWorker({ commit }, { id, ...payload }) {
    const { data } = await WorkersAPI.update(id, payload);
    commit(T.EC_UPSERT_WORKER, data);
    return data;
  },
  async deleteWorker({ commit }, id) {
    await WorkersAPI.delete(id);
    commit(T.EC_REMOVE_WORKER, id);
  },
  async importWorkers(_ctx, file) {
    const { data } = await WorkersAPI.import(file);
    return data;
  },
  async fetchFieldSummary({ commit }) {
    const { data } = await FieldAPI.summary();
    commit(T.EC_SET_FIELD_SUMMARY, data);
  },
  async fetchFieldByCity({ commit }) {
    const { data } = await FieldAPI.byCity();
    commit(T.EC_SET_FIELD_BY_CITY, data);
  },
  async fetchFieldHierarchy({ commit }) {
    const { data } = await FieldAPI.hierarchy();
    commit(T.EC_SET_FIELD_HIERARCHY, data);
  },
  async fetchMediaAssets({ commit }, opts) {
    const { data } = await MediaAPI.list(opts);
    commit(T.EC_SET_MEDIA_ASSETS, data);
  },
  async createMediaAsset({ commit }, { payload, files }) {
    const { data } = await MediaAPI.create(payload, files || []);
    commit(T.EC_UPSERT_MEDIA_ASSET, data);
    return data;
  },
  async updateMediaAsset({ commit }, { id, payload, files }) {
    const { data } = await MediaAPI.update(id, payload, files || []);
    commit(T.EC_UPSERT_MEDIA_ASSET, data);
    return data;
  },
  async updateMediaStatus({ commit }, { id, kanbanStatus }) {
    const { data } = await MediaAPI.updateStatus(id, kanbanStatus);
    commit(T.EC_UPSERT_MEDIA_ASSET, data);
    return data;
  },
  async deleteMediaAsset({ commit }, id) {
    await MediaAPI.delete(id);
    commit(T.EC_REMOVE_MEDIA_ASSET, id);
  },
  async fetchMap({ commit }) {
    const { data } = await MapAPI.get();
    commit(T.EC_SET_MAP, data.map || null);
    return data.map;
  },
  async generateMap({ commit }, { city, state }) {
    const { data } = await MapAPI.generate({ city, state });
    commit(T.EC_SET_MAP, data.map || null);
    return data.map;
  },
  async resetMap({ commit }) {
    await MapAPI.reset();
    commit(T.EC_SET_MAP, null);
  },
  searchCity(_ctx, { q, state }) {
    return MapAPI.searchCity({ q, state }).then(r => r.data);
  },
  async fetchPins({ commit }, opts) {
    const { data } = await PinsAPI.list(opts);
    commit(T.EC_SET_PINS, data);
  },
  async createPin({ commit }, payload) {
    const { data } = await PinsAPI.create(payload);
    commit(T.EC_UPSERT_PIN, data);
    return data;
  },
  async updatePin({ commit }, { id, ...payload }) {
    const { data } = await PinsAPI.update(id, payload);
    commit(T.EC_UPSERT_PIN, data);
    return data;
  },
  async deletePin({ commit }, id) {
    await PinsAPI.delete(id);
    commit(T.EC_REMOVE_PIN, id);
  },
};
